// extracted by mini-css-extract-plugin
export default {"dnbHeader":"Header-module--dnbHeader--f+rGF","dnbHeaderLogo":"Header-module--dnbHeaderLogo--r06MO"};